export const styles = {
  root: {
    height: "100vh",
    overflowY: "auto",
    p: 2,
    boxSizing: "border-box",
  },
};
